export const roundNumberToNDecimals = (number, n) => {
    const d = Math.pow(10, n);
    return Math.round((number + Number.EPSILON) * d) / d;
}